<template>
  <!-- 业务联系人 -->
  <div>
    <div class="fourthStep">
      <el-form
        ref="extTable"
        :model="{ extTable }"
        :rules="tableRules"
        label-width="100px"
      >
        <el-form-item class="addTabIndex" label-width="0px" label="" prop="">
          <el-table border :data="extTable" class="" max-height="99999">
            <el-table-column
              type="index"
              label="序号"
              width="60"
              fixed>
            </el-table-column>
            <el-table-column
              width="200px;"
              prop="titleName"
              label="姓名"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.personName`"
                  :rules="tableRules.personName"
                >

                  <el-input
                    style="width: 150px"
                    v-model="scope.row.personName"
                    placeholder="请输入"
                    clearable
                    maxlength="18"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column width="200px;" prop="remark" label="电话">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.phone`"
                  :rules="tableRules.phone"
                >
                  <el-input
                    style="width: 150px"
                    v-model="scope.row.phone"
                    v-input.phoneNum
                    placeholder="请输入"
                    clearable
                    maxlength="20"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column width="200px;" prop="remark" label="证件类型">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.cardType`"
                  :rules="tableRules.cardType"
                >

                  <el-select
                    style="width: 150px"
                    v-model="scope.row.cardType"
                    placeholder="请选择"
                  >
                    <el-option label="身份证" :value="0"></el-option>
                    <el-option label="护照" :value="1"></el-option>
                    <el-option label="其他" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="证件号码">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.idCard`"
                  :rules="tableRules.idCard"
                >

                  <el-input
                    style="width: 200px"
                    oninput="value=value.replace(/[^0-9a-zA-Z.]/g,'')"
                    v-model="scope.row.idCard"
                    placeholder="请输入"
                    clearable
                    maxlength="18"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              width="130px;"
              prop="remark"
              label="操作"
            >
              <template slot-scope="scope">
                <span
                  style="color: red;cursor: pointer;"
                  @click="deleteItem(scope)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label-width="0px" label="">
          <div class="addBtn" @click="addTable()">+添加业务联系人</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    extTable: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      checkOut:false,
      tableRules: {
        personName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        cardType: [
          { required: true, message: "请选择证件类型", trigger: "change" }
        ],
        idCard: [
          { required: true, message: "请输入证件号码", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入电话", trigger: "blur" },
          // {
          //   pattern: /^\d{11}$/,
          //   message: "手机号码输入错误"
          // }
        ],
        // deviceName: [
        //   { required: true, message: "请输入设备名称", trigger: "blur" },
        //   {
        //     pattern: /^[\u4E00-\u9FA5A-Za-z0-9_]+$/,
        //     message: "只支持中文、英文、数字"
        //   }
        // ]
      }
    };
  },
  methods: {
    ruleFun() {
      this.$refs["extTable"].validate(valid => {
        if (valid) {
          this.checkOut= true
        } else {
          console.log("error submit!!");
          this.checkOut=  false;
        }
      });
    },
    // 新增
    addTable() {
      if (this.extTable && this.extTable.length === 0) {
        this.extTable.push({
          id: 1,
          attribute1: "01"
        });
      } else {
        this.extTable.push({
          id: this.extTable[this.extTable.length - 1].id + 1,
          attribute1: "01"
        });
      }
    },
    deleteItem(scope) {
      this.extTable.filter((item, index) => {
        if (item.id === scope.row.id) {
          this.extTable.splice(index, 1);
        }
      });
    },
    // 上一步
    lastStep() {
      this.$emit("getStep", 2);
    }
  }
};
</script>

<style lang="scss" scoped>
.fourthStep {
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.el-form-item__content .el-button {
  width: 82px;
  height: 40px;
  background: #ff152e;
  border-radius: 2px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.el-form-item__content .stopBtn {
  border: 1px solid #ff152e;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff152e;
}

.addBtn {
  cursor: pointer;
  margin: 0px 0px 10px 0px;
  width: 1006px;
  height: 32px;
  line-height: 32px;
  border: 1px dashed #eee;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #252631;
}
.addTabIndex {
  width: 100%;
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.addTabIndex /deep/.tbody tr {
  height: 45px !important;
}

.addTabIndex /deep/.el-table {
  width: 1006px;
  margin: 0 auto;
  border-bottom: none;
  tbody tr {
    height: 60px !important;
  }
  th>.cell:before{
    content: "*";
    color: red;
    margin-right: 5px;
  }
  th:nth-child(6)>.cell:before{
    content: "";
    margin-right: 5px;
  }
  th:nth-child(1)>.cell:before{
    content: "";
    margin-right: 5px;
  }
  .addBtn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    border: 1px dashed #eee;
    border-radius: 4px;
    margin: 16px 0;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #252631;
  }
  .el-table-row .hover-row {
    background: #eee !important;
  }
}
</style>
